import { Link } from 'react-router-dom';
import { Instagram, Mail, MapPin, MessageCircle } from 'lucide-react';
import { BRAND, waLink } from '../lib/constants';

export const Footer = () => {
  return (
    <footer className="bg-[#0a0a0a] text-white" data-testid="site-footer">
      <div className="container-edge py-20 md:py-28 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-signature text-5xl text-[#eb5381] leading-none">findyourmua</div>
          <p className="mt-6 max-w-md text-neutral-300 text-base leading-relaxed">
            India's curated beauty marketplace — connecting people with verified makeup artists, hairstylists and beauty professionals across the country.
          </p>
          <div className="mt-8 flex gap-4">
            <a
              href={waLink('Hi FindYourMUA!')}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
              className="w-10 h-10 grid place-items-center border border-white/20 hover:bg-[#eb5381] hover:border-[#eb5381] transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
            </a>
            <a
              href="https://instagram.com/findyour.mua"
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 grid place-items-center border border-white/20 hover:bg-[#eb5381] hover:border-[#eb5381] transition-colors"
              data-testid="footer-instagram"
              aria-label="Instagram @findyour.mua"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href={`mailto:${BRAND.email}`}
              className="w-10 h-10 grid place-items-center border border-white/20 hover:bg-[#eb5381] hover:border-[#eb5381] transition-colors"
              data-testid="footer-email"
            >
              <Mail className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-[11px] uppercase tracking-[0.25em] text-neutral-400">Discover</h4>
          <ul className="mt-6 space-y-3 text-sm text-neutral-200">
            <li><Link to="/artists?occasions=Bridal" className="hover:text-[#eb5381]" data-testid="footer-discover-bridal">Bridal</Link></li>
            <li><Link to="/artists?occasions=Engagement" className="hover:text-[#eb5381]" data-testid="footer-discover-engagement">Engagement</Link></li>
            <li><Link to="/artists?occasions=Haldi+%2F+Mehendi" className="hover:text-[#eb5381]" data-testid="footer-discover-haldi">Haldi / Mehendi</Link></li>
            <li><Link to="/artists?occasions=Roka" className="hover:text-[#eb5381]" data-testid="footer-discover-roka">Roka</Link></li>
            <li><Link to="/artists?occasions=Party" className="hover:text-[#eb5381]" data-testid="footer-discover-party">Party</Link></li>
            <li><Link to="/artists?occasions=Editorial" className="hover:text-[#eb5381]" data-testid="footer-discover-editorial">Editorial</Link></li>
            <li><Link to="/artists?occasions=SFX" className="hover:text-[#eb5381]" data-testid="footer-discover-sfx">SFX</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-[11px] uppercase tracking-[0.25em] text-neutral-400">Company</h4>
          <ul className="mt-6 space-y-3 text-sm text-neutral-200">
            <li><Link to="/about" className="hover:text-[#eb5381]" data-testid="footer-company-about">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-[#eb5381]" data-testid="footer-company-contact">Contact Us</Link></li>
            <li><Link to="/careers" className="hover:text-[#eb5381]" data-testid="footer-company-careers">Careers</Link></li>
            <li><Link to="/blog" className="hover:text-[#eb5381]" data-testid="footer-company-journal">Journal</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-[11px] uppercase tracking-[0.25em] text-neutral-400">Studio</h4>
          <ul className="mt-6 space-y-3 text-sm text-neutral-200">
            <li className="flex items-start gap-3">
              <MessageCircle className="w-4 h-4 mt-1 text-[#eb5381]" />
              <a href={waLink()} target="_blank" rel="noreferrer" className="hover:text-white">{BRAND.whatsapp}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-1 text-[#eb5381]" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-white">{BRAND.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 text-[#eb5381]" />
              <span>Pan India</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="container-edge border-t border-white/10 py-8 flex flex-col md:flex-row items-center justify-between gap-6 text-xs text-neutral-500">
        <div>© {new Date().getFullYear()} {BRAND.domain}. Crafted with love in India.</div>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-white uppercase tracking-[0.2em] text-[10px]">Privacy Policy</Link>
          <Link to="/terms-conditions" data-testid="footer-terms-link" className="hover:text-white uppercase tracking-[0.2em] text-[10px]">Terms &amp; Conditions</Link>
          <Link to="/refund-policy" data-testid="footer-refund-link" className="hover:text-white uppercase tracking-[0.2em] text-[10px]">Refunds &amp; Cancellations</Link>
        </div>
        <div className="uppercase tracking-[0.25em]">Verified · Curated · Trusted</div>
      </div>
    </footer>
  );
};
